<template>
  <div class="coupon-info" :class="isDisabled ? 'coupon-bg-disabled' : 'coupon-bg'">
    <p class="coupon-amount">{{couponInfo.amountSplit && couponInfo.amountSplit.display}}</p>
    <p class="expire-time">{{leftDayText}}</p>
  </div>
</template>
<script>
import { sprintf } from '@didi/gettext'
import {
  trackOpenBoxResultSw
} from '../track'
export default {
  name: 'couponInfo',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    couponInfo: {
      type: Object,
      default: () => {}
    },
    trackCommonParams: {
      type: Object,
      default: () => {}
    },
    trackCouponInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    leftDayText () {
      if (!+this.couponInfo.isExpired) {
        if (+this.couponInfo.leftDay >= 7) {
          return `${this.gettext('有效期至')} ${this.couponInfo.expireTime}`
        } else if ((+this.couponInfo.leftDay === 0)) {
          return this.gettext('当天过期')
        } else {
          return sprintf(this.gettext('%s天后过期'), this.couponInfo.leftDay)
        }
      } else {
        return `${this.gettext('有效期至')} ${this.couponInfo.expireTime}`
      }
    }
  },
  data () {
    return {

    }
  },
  mounted () {
    trackOpenBoxResultSw({
      page_type: 1, // 成功领取
      order_id: this.params.orderId,
      ...this.trackCouponInfo,
      ...this.trackCommonParams
    })
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/main"
@import "~@/common/stylus/variables"
.coupon-info
  width 578px
  padding 23px 0 50px
  display flex
  flex-direction column
  justify-content center
  align-items center
  button-font-color()
  &.coupon-bg
    share-coupon-bg()
    background-size 100% 100%
  &.coupon-bg-disabled
    share-coupon-bg-disabled()
    background-size 100% 100%
  .coupon-amount
    margin-bottom 14px
    font-family 'Aspira Demi'
    font-size 84px
    text-align right
  .expire-time
    font-family 'Aspira Light'
    font-size 24px
    text-align: left
</style>